import React from 'react'
import { RowRendiciones } from './RowRendiciones.jsx'

import * as css from '../../asignacion-fondos/Fondos.css'

let PropTypes = React.PropTypes

export class TableRendiciones extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        let totalRendiciones = this.props.rendiciones.length
        return (
            <div className={"panel panel-default "+css.panelInventarios}>
                <div className={"panel-heading "+css.panelHeadingDetalle}><b>Rendiciones</b></div>
                <div className={"panel-body "+css.panelBodyCustom}>
                    <TablaRendiciones>
                        {_.range(0, totalRendiciones).map(index=>{
                            let rendicion = this.props.rendiciones[index]
                            return <RowRendiciones
                                key={index}
                                index={index}
                                rendicion={rendicion}
                            />
                        })}
                    </TablaRendiciones>
                </div>
            </div>
        )
    }
}
let TablaRendiciones = ({children}) =>
    <table className={"table table-condensed "+css.tableFixed+" "+css.panelDetalleInventarios}>
        <colgroup>
            <col className={css.colIndex}/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
        </colgroup>
        <thead>
        <tr>
            <th>#</th>
            <th>Origen</th>
            <th>Desde</th>
            <th>Hasta</th>
            <th>Total Viático</th>
            <th>Total a Rendir</th>
            <th>Total Gastado</th>
            <th>Diferencia</th>
            <th>Detalles</th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/rendiciones/TableRendiciones.jsx